module.exports = __webpack_public_path__ + "img/no-pb.f51e74cb.png";